import { useSelector } from 'react-redux';

/**
 * KZ-компания или нет. Логика складских остатков/резервов и кнопка
 * «Связаться с менеджером» нужны только казахстанским клиентам — для
 * RU всё это скрываем.
 *
 * Сигнал страны берём из валюты корзины: бэк выставляет cart.currency
 * = 'kzt' для KZ и 'rub' для RU по стране юр.лица (см. CartViewSet.list
 * и OrderSerializer.create). Это уже загруженное app-wide значение,
 * не требует отдельного запроса. Пока корзина не загружена (currency
 * пустая) — считаем не-KZ, т.е. по умолчанию прячем остатки.
 */
export const useIsKzCompany = (): boolean =>
  String(useSelector((s: any) => s.cart?.currency) || '').toLowerCase() === 'kzt';
